import { Document } from '@tiptap/extension-document';
import { Fragment, Slice } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

/** One internal paragraph keeps Heading authoring inline-only while native alignment targets a block. */
export const headingDocument = Document.extend({
  content: 'paragraph',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          // A one-block document would otherwise silently discard every pasted line after the first.
          transformPastedText: (text) => text.replace(/\s*\r?\n+\s*/g, ' '),
          transformPasted: (slice) => {
            const textBlocks: Array<typeof slice.content.content[number]> = [];
            slice.content.descendants((node) => {
              if (node.isTextblock) {
                textBlocks.push(node);
                return false;
              }
              return true;
            });
            if (textBlocks.length <= 1) {
              return slice;
            }

            const [firstBlock] = textBlocks;
            const { schema } = firstBlock.type;
            const inlineContent = textBlocks.flatMap((block, index) => [
              ...(index === 0 ? [] : [schema.text(' ')]),
              ...block.content.content,
            ]);
            const paragraph = schema.nodes.paragraph.create(null, Fragment.fromArray(inlineContent));
            return new Slice(Fragment.from(paragraph), 0, 0);
          },
        },
      }),
    ];
  },
});
